import userRoles from '../type/use-role.type';

export default [
  {
    title: userRoles.admin.title,
    field: userRoles.admin.value,
    options: userRoles.admin.value,
  },
  {
    title: userRoles.user.title,
    field: userRoles.user.value,
    options: userRoles.user.value,
  },
  {
    title: userRoles.integration.title,
    field: userRoles.integration.value,
    options: userRoles.integration.value,
  },
]